package com.essntl.features.itinerary.ui.edit_itinerary_service

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Modifier
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.contact.ui.ContactState
import com.essntl.features.itinerary.ui.edit_itinerary_service.components.EditItineraryServiceColumn
import com.essntl.features.itinerary.ui.edit_itinerary_service.components.EditItineraryServiceHeader
import com.essntl.features.itinerary.ui.rememberDateRange
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.uikit.components.utils.spacing
import core.validation.EsInputState

@Composable
fun EditItineraryServiceScreen(
    state: EditItineraryServiceState,
    onEvent: (EditItineraryServiceEvent) -> Unit,
    onNavigation: (EditItineraryServiceNavigation) -> Unit,
    validation: EditItineraryServiceValidation,
    category: CategoryModel?,
    contactState: ContactState,
    contactEvent: (ContactEvent) -> Unit,
) {
    val itineraryService = state.itineraryService.value
    val proposal = state.getItinerary.data?.proposal ?: ProposalModel.empty

    val startDateRange = rememberDateRange(itineraryService.startDate, proposal.fromDate, proposal.toDate)
    val endDateRange = rememberDateRange(itineraryService.endDate, proposal.fromDate, proposal.toDate)

    LaunchedEffect(key1 = startDateRange, key2 = endDateRange) {
        if ((startDateRange != null && !startDateRange) || endDateRange != null && !endDateRange) {
            if (startDateRange != null && !startDateRange) {
                validation.editItineraryServiceForm.dateRange.firstErrorMessage = "Not within itinerary dates"
                validation.editItineraryServiceForm.dateRange.firstState = EsInputState.Error
            }

            if (endDateRange != null && !endDateRange) {
                validation.editItineraryServiceForm.dateRange.secondErrorMessage = "Not within itinerary dates"
                validation.editItineraryServiceForm.dateRange.secondState = EsInputState.Error
            }
        } else {
            validation.editItineraryServiceForm.dateRange.validate()
        }
    }

    Column(
        modifier = Modifier
            .fillMaxSize(),
    ) {
        EditItineraryServiceHeader(
            state = state,
            onEvent = onEvent,
            onNavigation = onNavigation,
        )

        Spacer(modifier = Modifier.height(1f.spacing))

        EditItineraryServiceColumn(
            state = state,
            onEvent = onEvent,
            onNavigation = onNavigation,
            validation = validation,
            category = category,
            contactState = contactState,
            contactEvent = contactEvent,
        )
    }
}